import React from 'react';
import PropTypes from 'prop-types';
import ConnectButton from '../../../pages/_banner/ConnectButton';
import Wrapper from '../../../pages/_banner/Wrapper';
import useDialogLauncher from '../../_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import { useConnect } from '../../../../hooks/@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import usePageRouter from '../../_hooks/usePageRouter';
import useRouter from '../../../hooks/useRouter';

CompletedBanner.propTypes = {
  project: PropTypes.object.isRequired
};

export default function CompletedBanner(props) {
  const { project, creator } = props;

  const launch = useDialogLauncher();
  const dialogRouter = useRouter();
  const pageRouter = usePageRouter();

  const evaluation = useConnect('evaluationProjectEducator.first', {
    where: {
      eager: {
        $where: {
          projectId: project.id,
          userId: project.data.creatorId
        }
      }
    }
  });

  function onViewEvaluation() {
    launch(DialogManager.EvaluationProjectEducator.Config(evaluation.id));
  }

  function onDuplicate() {
    launch(DialogManager.ProjectDuplicate.Config(project.id));
  }

  function onViewProject() {
    dialogRouter.history.push('/view')
  }

  function onEditEvaluation() {
    pageRouter.history.push(`/evaluation-project-educator/${evaluation.id}`);
  }

  if (evaluation.state === PayloadStates.FETCHING) {
    return (
      <Wrapper
        color="green"
        creator={creator}
        title={(
          <div className="w-24">
            <Loader />
          </div>
        )}
      />
    );
  }

  if (
    evaluation.state === PayloadStates.RESOLVED &&
    !evaluation.data.completed
  ) {
    return (
      <Wrapper
        color="green"
        creator={creator}
        title={(
          <>
            Your project is complete. Let's tell people about it!
          </>
        )}
        subtitle={(
          <>
            Congratulations on bringing your project to life! Share your experience with our
            community to highlight your impact and inspire others.
          </>
        )}
      >
        <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
          <ConnectButton outline={true} onClick={onViewProject}>
            View your project
          </ConnectButton>
          <ConnectButton color="green" onClick={onEditEvaluation}>
            Share your impact!
          </ConnectButton>
        </div>
      </Wrapper>
    );
  }

  return (
    <Wrapper
      color="green"
      creator={creator}
      title={(
        <>
          Thanks for completing this project!
        </>
      )}
      subtitle={(
        <>
          Take a moment to celebrate! Thanks for creating meaningful opportunities for
          learners. Want to revisit or build on this idea? You can duplicate your project below.
        </>
      )}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        {evaluation.state === PayloadStates.RESOLVED && (
          <ConnectButton outline={true} onClick={onViewEvaluation}>
            Revisit your impact
          </ConnectButton>
        )}
        <ConnectButton outline={true} color="green" onClick={onDuplicate}>
          Duplicate your project
        </ConnectButton>
      </div>
    </Wrapper>
  );
};
